export default __webpack_public_path__ + "static/media/hanaauerova.c4da954e.png";